module.exports = __webpack_public_path__ + "static/media/success-green.bf03b8b2.svg";